module.exports = __webpack_public_path__ + "static/img/vip-info5.cf8b5c3b.png";